import GoldButton from "../ui/GoldButton";
import ScrollReveal from "../motion/ScrollReveal";
import BackgroundGradient from "../effects/BackgroundGradient";
import MagneticButton from "../motion/MagneticButton";
import FloatingShapes from "../graphics/FloatingShapes";

export default function HomeCTA() {
  return (
    <section
      style={{
        background: "#050505",
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "120px 40px",
        borderTop: "0.5px solid rgba(212,168,67,0.12)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <BackgroundGradient />
      <FloatingShapes seed={99} count={8} />

      <div style={{ textAlign: "center", maxWidth: 640, position: "relative", zIndex: 2 }}>
        <ScrollReveal direction="up" delay={0}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 32 }}>
            <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#D4A843", display: "inline-block" }} />
            <span
              style={{
                fontFamily: "'Barlow Condensed', sans-serif",
                fontWeight: 700,
                fontSize: 11,
                letterSpacing: "0.3em",
                color: "#D4A843",
                textTransform: "uppercase",
              }}
            >
              READY TO BUILD?
            </span>
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.15}>
          <div style={{ marginBottom: 32 }}>
            <div
              style={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: 300,
                fontSize: "clamp(48px, 6vw, 80px)",
                color: "#F8F4EC",
                lineHeight: 0.9,
              }}
            >
              Your next system
            </div>
            <div
              style={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: 300,
                fontSize: "clamp(48px, 6vw, 80px)",
                color: "#F8F4EC",
                lineHeight: 0.95,
              }}
            >
              starts <span style={{ color: "#D4A843", fontStyle: "italic" }}>here.</span>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.3}>
          <p
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: 300,
              fontSize: 16,
              color: "#908A83",
              lineHeight: 1.7,
              marginBottom: 40,
            }}
          >
            Book a free 30-minute discovery call. We&apos;ll scope your project, recommend a solution, and give you a fixed quote. No obligation. No sales pitch.
          </p>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.45} scale>
          <MagneticButton>
            <div className="btn-gold-fill cta-pulse-wrap" style={{ borderRadius: 4 }}>
              <GoldButton href="/contact" size="lg">
                BEGIN YOUR PROJECT →
              </GoldButton>
            </div>
          </MagneticButton>
        </ScrollReveal>

        <ScrollReveal direction="none" delay={0.6}>
          <div style={{ marginTop: 20 }}>
            <a
              href="/work"
              className="nav-link-draw"
              style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300, fontSize: 13, color: "#908A83" }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#D4A843";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#908A83";
              }}
            >
              or explore our work first →
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
